module.exports = __webpack_public_path__ + "static/img/dk-singh-rgb.9cb81b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/dk-singh-rgb.jpg
// module id = e/t8
// module chunks = 0